import { HighlightType } from "@/grid/GridCellHighlightProvider";
import { EditableTextbox } from "@/overlay/components/CommonParts/EditableTextbox";
import { ManageActionPanel } from "@/overlay/components/LayerStackWindow/ManageActionPanel/ManageActionPanel";
import { ModeSwitchableForm } from "@/overlay/components/SmartForm/SmartFormUtils/FormComponents/ModeSwitchableFormProps";
import { hasId } from "@/utility/typeGuard";
import { t } from "@lingui/core/macro";
import { useNoteForm } from "../controller/NoteFormController";

/**
 * Responsible for rendering the whole layer form and send back the data on submit hadler.
 */
export function NoteForm({ toolId }: { toolId: number }) {
  const { defaultFormData, submitMode, onSubmit, onRemove, onCancel, setHighlighted, formMethods } =
    useNoteForm(toolId);

  const formData = formMethods.watch();

  return (
    <ModeSwitchableForm
      className="box-section"
      onSubmit={formMethods.handleSubmit(onSubmit)}
      onCancel={onCancel}
      submitMode={submitMode}
      onMouseEnter={() => {
        if (hasId(defaultFormData)) {
          setHighlighted({
            type: HighlightType.NOTE,
            id: defaultFormData.id,
          });
        }
      }}
      onMouseLeave={() => {
        setHighlighted(undefined);
      }}
    >
      <div className="title-row">
        <EditableTextbox
          className={"editable-map-title"}
          value={formData.title ?? ""}
          placeholder={formData.title === "" ? t`Untitled Note` : undefined}
          blurOnEnterKey
          onSave={(val) => {
            onSubmit({ title: val });
          }}
        />
        <ManageActionPanel onRemove={onRemove} />
      </div>
    </ModeSwitchableForm>
  );
}
